import { throttle } from 'lodash';
import $ from 'jquery';

class Cms {
    constructor(el) {
        if (!el) {
            return;
        }
        this.el = el;
        this.floatingNavigation = this.el.find('.sidebar__content-area--floating');
        if (!this.floatingNavigation.length)
        {
            return;
        }
        $(window).resize((() => this.centerSidebar()).bind(this));
        this.centerSidebar();

        this.sidebarNavigation = this.el.find('.sidebar__navigation');
        if (this.sidebarNavigation.length) {
            this.topicSections = this.el.find('.topics__section');
            this.sidebarItems = this.sidebarNavigation.find('.sidebar__items--desktop .sidebar__item');
            this.activeSectionIndex = 0;
            this.scrollPosition = 0;
            this.highlightClosestSection(true);
            $(window).scroll(throttle(this.highlightClosestSection.bind(this), 250));

        }



    }
    centerSidebar(offset = 0) {
        const height = (offset + window.innerHeight - this.floatingNavigation[0].offsetHeight) / 2 + 'px';
        this.floatingNavigation[0].style.top = height;
    }
    highlightClosestSection(force = false) {
        if (Math.abs(this.scrollPosition - $(window).scrollTop()) > 50 || force)
        {
            const sectionIndex = this.getClosestSectionInViewIndex();
            this.highlightSection(sectionIndex, force);
            this.scrollPosition = $(window).scrollTop();
        }
    }
    getClosestSectionInViewIndex() {
        //find whats closer to the middle of the screen, the bottom or the top of a section
        //test all the tops
        const closestTopInViewIndex =$.makeArray(this.topicSections).map(el => Math.abs(el.getBoundingClientRect().top-window.innerHeight/2))
            .reduce((iMin, el, i, arr) => el < arr[iMin] ? i : iMin, 0);
        //test all the bottoms
        const closestBottomInViewIndex = $.makeArray(this.topicSections).map(el => Math.abs(el.getBoundingClientRect().bottom-window.innerHeight/2))
            .reduce((iMin, el, i, arr) => el < arr[iMin] ? i : iMin, 0);
        //which one is smaller?
        const closestItemInViewIndex = Math.abs(this.topicSections[closestTopInViewIndex].getBoundingClientRect().top) < Math.abs(this.topicSections[closestTopInViewIndex].getBoundingClientRect().bottom) ? closestTopInViewIndex : closestBottomInViewIndex;
        return closestItemInViewIndex;
    }
    highlightSection(newSectionIndex, force= false )
    {
        if (this.activeSectionIndex === newSectionIndex && !force)
        {
            return;
        }
        $(this.sidebarItems[this.activeSectionIndex]).removeClass('bold');
        $(this.sidebarItems[newSectionIndex]).addClass('bold');
        this.activeSectionIndex = newSectionIndex;
    }
}

export default Cms;